import React, { FC } from 'react';
import { Filter, DateInput, TextInput } from 'react-admin';
import { UserDto } from '@vatos-pas/common';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';
import { AppRole } from 'providers/roles';
import { PermissionsProvider } from 'providers/permissionsProvider';
import { LazyReferenceInput } from 'components/LazyAutoCompleteInput';

const useStyles = makeStyles({
  filterDate: {
    width: '100%',
    minWidth: '200px',
  },
});

export const ArchivedJobsFilters: FC<any> = props => {
  const { hasRole } = PermissionsProvider.useContainer();
  const classes = useStyles();
  const isSupervisor = hasRole(AppRole.Supervisor);

  return (
    <Box>
      <Filter {...props}>
        {!isSupervisor && (
          <LazyReferenceInput
            label="Supervisor"
            source="supervisorUserIds||$cont"
            reference="user"
            alwaysOn
            filterToQuery={value => {
              if (value) {
                return {
                  s: {
                    $and: [
                      {
                        $or: [
                          { firstName: { $cont: value } },
                          { lastName: { $cont: value } },
                        ],
                      },
                      {
                        'userRoles.role.name': { $eq: AppRole.Supervisor },
                      },
                    ],
                  },
                };
              } else {
                return {
                  s: { 'userRoles.role.name': { $eq: AppRole.Supervisor } },
                };
              }
            }}
            sort={{ field: 'firstName', order: 'ASC' }}
            optionText={(user: UserDto) => `${user.firstName} ${user.lastName}`}
            optionValue="id"
          />
        )}
        <TextInput
          label="Lot"
          source="jobLot||$eq"
          alwaysOn
          resettable
          data-cy="archivedJobsFilterLot"
        />
        <TextInput
          label="Block"
          source="jobBlock||$eq"
          alwaysOn
          resettable
          data-cy="archivedJobsFilterBlock"
        />
        <LazyReferenceInput
          label="Builder"
          source="builderId"
          reference="builder"
          resettable
          data-cy="archivedJobsFilterBuilder"
          alwaysOn
          allowEmpty={false}
          filterToQuery={value => (value ? { name: value } : {})}
          sort={{ field: 'name', order: 'ASC' }}
          optionText="name"
          optionValue="id"
        />
        <LazyReferenceInput
          label="Subdivision"
          source="subdivisionId"
          reference="subdivision"
          resettable
          data-cy="archivedJobsFilterSubdivision"
          alwaysOn
          allowEmpty={false}
          filterToQuery={value => (value ? { name: value } : {})}
          sort={{ field: 'name', order: 'ASC' }}
          optionText="name"
          optionValue="id"
        />
        <TextInput
          label="Address"
          alwaysOn
          resettable
          source="address1||$cont"
          data-cy="archivedJobsFilterAddress"
        />
        <DateInput
          className={classes.filterDate}
          label="Project Start Date On or After"
          source="poSignedAt||$gte"
          resettable
        />
        <DateInput
          className={classes.filterDate}
          label="Project Start Date On or Before"
          source="poSignedAt||$lte"
          resettable
        />
        <DateInput
          className={classes.filterDate}
          label="Last Update On or After"
          source="lastEventAt||$gte"
          resettable
        />
        <DateInput
          className={classes.filterDate}
          label="Last Update On or Before"
          source="lastEventAt||$lte"
          resettable
        />
      </Filter>
    </Box>
  );
};
